import React from 'react';
import {Layout} from '../../components/layout/Layout';
import {useAuth} from '../../hooks/useAuth';

export const HomePage: React.FC = () => {
    const {user} = useAuth();

    return (
        <Layout>
            <div className="space-y-8">
                {/* Welcome Section */}
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
                    <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-4">
                        Welcome back, {user?.username}!
                    </h1>
                    <p className="text-lg text-gray-600 dark:text-gray-300">
                        Manage your freight operations efficiently with our comprehensive system.
                    </p>
                </div>

                {/* Feature Cards Grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {/* Fleet Management Card */}
                    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6 hover:shadow-md transition-shadow duration-200">
                        <div className="flex justify-center mb-4">
                            <svg
                                className="w-16 h-16 text-primary-600 dark:text-primary-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={1.5}
                                    d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
                                />
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={1.5}
                                    d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1v-1a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1h4"
                                />
                            </svg>
                        </div>
                        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 text-center mb-2">
                            Fleet Management
                        </h2>
                        <p className="text-sm text-gray-600 dark:text-gray-300 text-center">
                            Track and manage your entire vehicle fleet with real-time updates and comprehensive reporting.
                        </p>
                    </div>

                    {/* Voyage Tracking Card */}
                    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6 hover:shadow-md transition-shadow duration-200">
                        <div className="flex justify-center mb-4">
                            <svg
                                className="w-16 h-16 text-primary-600 dark:text-primary-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={1.5}
                                    d="M3 21l3.75-3.75M3 21v-5.25M3 21h5.25M9 3h6M12 3v3M3 12h3M18 12h3M12 18v3M15.75 6.75L12 10.5l-3.75-3.75"
                                />
                                <circle cx="12" cy="12" r="3" strokeWidth={1.5} />
                            </svg>
                        </div>
                        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 text-center mb-2">
                            Voyage Tracking
                        </h2>
                        <p className="text-sm text-gray-600 dark:text-gray-300 text-center">
                            Monitor shipping voyages from departure to arrival with detailed status tracking and notifications.
                        </p>
                    </div>

                    {/* Cargo Operations Card */}
                    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6 hover:shadow-md transition-shadow duration-200">
                        <div className="flex justify-center mb-4">
                            <svg
                                className="w-16 h-16 text-primary-600 dark:text-primary-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={1.5}
                                    d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                                />
                            </svg>
                        </div>
                        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 text-center mb-2">
                            Cargo Operations
                        </h2>
                        <p className="text-sm text-gray-600 dark:text-gray-300 text-center">
                            Manage container bookings, loading lists, and freight manifests with streamlined documentation.
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    );
};
